import { HttpStatusCode } from "axios";
import { aunjaiBackendClient } from "../lib/axios";

class AunjaiBackendService {
  constructor(_aunjaiBackendClient) {
    this._aunjaiBackendClient = _aunjaiBackendClient;
  }

  async updateNotificationMarkAsRead({ borrowerId }) {
    try {
      const {
        data: { data, message },
        status,
      } = await this._aunjaiBackendClient.post(
        `/notification/line/mark-as-read/${borrowerId}`
      );

      if (status !== HttpStatusCode.Ok) {
        console.error("Request failed:", message || "Unknown error");
      }

      return data;
    } catch (error) {
      console.warn("Notification service unavailable:", error.message);
      return null;
    }
  }

  async getLineNotificationHistories({ borrowerId, limit, page }) {
    try {
      const {
        data: { data, total, totalUnread, message },
        status,
      } = await this._aunjaiBackendClient.get(
        `/notification/line?borrowerId=${borrowerId}&limit=${limit}&page=${page}`
      );

      if (status !== HttpStatusCode.Ok) {
        console.error("Request failed:", message || "Unknown error");
      }

      return { data, total, totalUnread };
    } catch (error) {
      console.warn("Notification service unavailable:", error.message);
      return { data: [], total: 0, totalUnread: 0 };
    }
  }

  translateErrorMessage(error) {
    switch (error.message) {
      case "MSISDN is invalid.":
        return "หมายเลขโทรศัพท์ไม่ถูกต้อง";
      default:
        return "เกิดข้อผิดพลาด";
    }
  }

  async sendOTP({ msisdn }) {
    const {
      data: { data, message },
      status,
    } = await this._aunjaiBackendClient.post("/otp/send", { msisdn });

    if (status !== HttpStatusCode.Created) {
      throw new Error(message);
    }

    return data;
  }

  async verifyOTP({ ref, otp }) {
    const {
      data: { data, message },
      status,
    } = await this._aunjaiBackendClient.post("/otp/verify", { ref, otp });

    if (status !== HttpStatusCode.Ok) {
      throw new Error(message);
    }

    return data;
  }
}

export const aunjaiBackendService = new AunjaiBackendService(
  aunjaiBackendClient
);
